export default "__VITE_ASSET__BzbbgLJV__"